var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-caption d-inline-flex w-100 align-center font-weight-bold"},[_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.$t('button.next')))]),_c('v-icon',[_vm._v("mdi-chevron-right")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }